import React from 'react';
import MobileMenu from './mobileMenu';

const Header = () => {
  return (
    <header className="header">
      <div className="header_top">
        <div className="top-header-content">
          <div className="top-header-grid">
            <div className="top-header-part">
              <ul>
                <li><span className="color-coral">Personal</span></li>
                <li><span className="with-hover-bold">Business</span></li>
              </ul>
            </div>
            <div className="top-header-part">
              <ul>
                <li><span>1-833-VERIZON</span></li>
                <li><span className="with-hover-bold">Contact us</span></li>
                <li><span className="with-hover-bold">Support</span></li>
                <li><span className="with-hover-bold">Stores</span></li>
                <li><span className="with-hover-bold">Coverage map</span></li>
                <li><span className="with-hover-bold">Español</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="header_main">
        <div className="top-header-content -big">
          <div className="top-header-grid">
            <div className="top-header-part main-header">
              <ul>
                <li>
                  <div className="header_logo">
                    <svg className="icon -header-logo">
                      <use xlinkHref="#svg_verizon-long-branded" />
                    </svg>
                  </div>
                </li>
              </ul>
              <ul className="main-menu mobile-hide">
                <li><span className="with-hover-decoration">Mobile</span></li>
                <li><span className="with-hover-decoration">Home Internet</span></li>
                <li><span className="with-hover-decoration">Shop</span></li>
                <li><span className="with-hover-decoration">Deals</span></li>
              </ul>
            </div>
            <div className="top-header-part main-header">
              <ul className="main-menu">
                <li><div className="search" data-placeholder-text="Search Verizon" /></li>
                <li><span className="with-hover-decoration -top-two">Sign in</span></li>
                <li><div className="cart-item" /></li>
                <li className="desktop-hide"><MobileMenu /></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
